export default __webpack_public_path__ + "images/sv_flag.png";